import { combineReducers, configureStore } from '@reduxjs/toolkit';
import authReducer from "./authSlice";
import walletReducer from "./walletSlice";
import transactionReducer from "./transactionSlice";
import reportReducer from "./reportSlice";
import searchReducer from "./searchSlice";
import languageReducer from "./languageSice"
import {
    persistStore,
    persistReducer,
    FLUSH,
    REHYDRATE,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const persistConfig = {
    key: 'root',
    version: 1,
    storage,
}


const rootReducer = combineReducers({
    auth: authReducer,
    wallet: walletReducer,
    transaction: transactionReducer,
    report: reportReducer,
    search: searchReducer,
    lang : languageReducer,
});


const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
            },
        }),
})

export let persistor = persistStore(store);
